import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";

interface UserDeactivationModalProps {
  showUserDeactivationModal: boolean;
  setShowUserDeactivationModal: React.Dispatch<React.SetStateAction<boolean>>;
  handleUserDeactivation: (event:React.ChangeEvent<HTMLInputElement  | {value: string, name: string}>)=> void;
  handleUserStatus:()=>void;
  setConfirmationMessage: React.Dispatch<React.SetStateAction<boolean>>;
  confirmationMessage:boolean,
  userData:any,
  setUserData:React.Dispatch<React.SetStateAction<any>>;
}

const UserDeactivationModal: React.FC<UserDeactivationModalProps> = ({
  showUserDeactivationModal,
  setShowUserDeactivationModal,
  handleUserDeactivation,
  handleUserStatus,
  setConfirmationMessage,
  confirmationMessage,
  userData,
  setUserData
}) => {

  const handleConfirmationMessage = () => {
    setConfirmationMessage(true);
  };

  const handleModalClose = () => {
    setShowUserDeactivationModal(false);
    setConfirmationMessage(false);
    setUserData((prev:any) => ({
      ...prev,
      statusChangeReason: null,
      statusChangeComment:null
    }));
  };

  const userStatusInactiveReasons = [
    "The user is not with the organization",
    "The user does not need CSL access",
    "Moved to a different location",
    "Other (Please specify)",
  ];

  const userStatusActiveReasons = [
    "The user rejoined the organization",
    "Other (Please specify)",
  ];

  return (
    <Modal
      open={showUserDeactivationModal}
      onClose={() => setShowUserDeactivationModal(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: "relative",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "80%", sm: "45%" },
          bgcolor: "background.paper",
          boxShadow: 24,
          borderRadius: "4px",
          pt: 2,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Box className="px-2 py-2 md:px-4">
          <Typography
            sx={{
              fontSize: { xs: "1rem", sm: "1.5rem" },
              display: "flex",
              justifyContent: "center",
              fontWeight:"600",
            }}
          >
            Confirm User State
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "4rem",
            }}
          >
            {!confirmationMessage ? (
              <Box className="flex flex-col gap-6 pt-8">
                <FormControl fullWidth>
                  <InputLabel shrink>{`Reason to make User ${userData.isActive ? "Inactive" : "Active" }`}</InputLabel>
                  <Select
                    defaultValue=""
                    displayEmpty
                    label={`Reason to make User ${userData.isActive ? "Inactive" : "Active" }`}
                    name="statusChangeReason"
                    value={userData.statusChangeReason}
                    onChange={handleUserDeactivation}
                    sx={{fontWeight:400,fontSize:"16px", width:{lg:"50%"}}}
                    renderValue={(selected) => {
                      if (!selected) {
                        return <Typography>Select Reason</Typography>;
                      }
                      return selected;
                    }}
                  >{userData.isActive ?
                    userStatusInactiveReasons.map((reason) => (
                      <MenuItem key={reason} value={reason}>{reason}</MenuItem>
                    )) : 
                    userStatusActiveReasons.map((reason) => (
                      <MenuItem key={reason} value={reason}>{reason}</MenuItem>
                    ))
                  }
                  </Select>
                </FormControl>

                <FormControl fullWidth>
                  <TextField
                    label="Your Comment"
                    placeholder="Add Comment"
                    name="statusChangeComment"
                    multiline
                    minRows={2}
                    maxRows={2}
                    fullWidth
                    variant="outlined"
                    value={userData.statusChangeComment}
                    onChange={handleUserDeactivation}
                    slotProps={{
                      inputLabel:{
                        shrink: true,
                      }
                    }}
                  />
                </FormControl>
              </Box>
            ) : (
              <Box className="pt-2">
                <Typography color="#FF0000" sx={{ fontWeight: 400}}>
                  {userData.isActive ? "Are you sure you want to disable this user?" : "Are you sure you want to enable this user?"}
                </Typography>
                <Typography
                  color="#FF0000"
                  sx={{ fontWeight: 400}}
                >
                 {userData.isActive ? "Disabling the user will restrict user to access the portal": "Enabling the user will allow user to access the application"}
                </Typography>
              </Box>
            )}

            <Box className="flex justify-end gap-4 mb-4">
              <Button
                sx={{
                  textTransform: "none",
                  border: "1px solid #318FE0",
                  color: "#318FE0",
                  padding:"0.5rem 0rem",
                  width:{xs:"50%", md:"25%"}
                }}
                onClick={handleModalClose}
              >
                {confirmationMessage ? "No" : "Cancel"}
              </Button>
              <Button
                sx={{
                  textTransform: "none",
                  backgroundColor: !userData.statusChangeReason ? "#A1A3A6" : "#318FE0",
                  color: "#ffffff !important",
                  padding:"0.5rem 0rem",
                  width:{xs:"50%", md:"25%"}
                }}
                onClick={
                  confirmationMessage ? handleUserStatus : handleConfirmationMessage
                }
                disabled={!userData.statusChangeReason}
              >
                {confirmationMessage ? "Yes" : "Confirm"}
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default UserDeactivationModal;
